module.exports = __webpack_public_path__ + "img/melvid-planejamento.3eb0fc8b.png";